import { Avatar as AntAvatar } from 'antd';
import styled from 'styled-components';
export const Avatar = styled(AntAvatar) `
	background: #23a52c;
`;
